import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';

export const ImageGridContainer: StyleRule = () => ({
    '&:hover .cta-image-grid__label-container .cta-image-grid__noun-label': {
        textDecoration: 'underline',
    },
    width: '100%',
});

export const ImageGrid: StyleRule = () => ({
    gap: pxToRem(6),
    width: '100%',
});

export const SmallImagesContainer: StyleRule = () => ({
    position: 'relative',
    gap: pxToRem(6),
});

export const LargeImagesContainer: StyleRule = () => ({
    position: 'relative',
    '& img': {
        height: '100%',
        width: '100%',
        objectFit: 'cover',
    },
});

export const ImageContainer: StyleRule = () => ({
    height: '100%',
    width: '100%',
    position: 'relative',
    aspectRatio: '1/1',
});

export const GridLabel: StyleRule = () => ({
    marginTop: pxToRem(23),
});

export const GridLabelVerb: StyleRule = () => ({
    fontSize: pxToRem(16),
    textTransform: 'capitalize',
    color: 'rgba(147, 149, 152, 1)',
    letterSpacing: '-0.01em',
    lineHeight: '100%',
});

export const GridLabelNoun: StyleRule = () => ({
    fontSize: pxToRem(16),
    textTransform: 'uppercase',
    letterSpacing: '-0.02em',
});
